import { auth } from '@/service/http';
import enviromentData from '@/store/enviroment-data';

let app = null;
export const getApp = () => {
    return app;
};
export const setApp = value => {
    app = value;
};

export const getUserApps = async () => {
    if (enviromentData.state.apps.length === 0) {
        try {
            const resp = await auth('admin./user/app/get');
            if (!resp.result) {
                throw new Error('e5d3c8d8-4f74-4b40-b605-578c52cf33ae');
            }
            enviromentData.state.apps = resp.items;
            return { result: true, success: true, items: enviromentData.state.apps };
        } catch (error) {
            return {
                result: false,
                error: error.message,
                uuid: '988cefc6-7274-422f-aaa5-1785d183a2be',
            };
        }
    } else {
        return { result: true, success: true, items: enviromentData.state.apps };
    }
};

export const getUserDeparts = async () => {
    if (enviromentData.state.departs.length === 0) {
        try {
            const resp = await auth('admin./department/start-list/get');
            if (!resp.result) {
                throw new Error('fcd9bb36-06ad-4dd1-95fd-ab05cd46749b');
            }
            enviromentData.state.departs = resp.items;
            return { result: true, success: true, items: enviromentData.state.departs };
        } catch (error) {
            return {
                result: false,
                error: error.message,
                uuid: '79627c43-4a4a-4a10-b9c6-b3772d833230',
            };
        }
    } else {
        return { result: true, success: true, items: enviromentData.state.departs };
    }
};
